import { getAppConfig } from '@services/config';

import { useCart } from '@hooks/use-cart';

const appConfig = getAppConfig();

export function useShouldShowProBillingStep(): boolean {
    const { byouCart } = useCart();

    return appConfig.features.rfeEnabled && byouCart?.isProBillingRequired === true;
}
